import { Component, OnInit } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { uiHelper } from '~/helpers/ui.helper';

declare let $;
declare let SetLanguage: any;
declare let refreshSecondScreen;
import { interval } from 'rxjs';

import { scoreBoxBannerUrl, scoreSplashUrl } from '@env/environment';
import { SideBannerModel } from '~/legacy/ts/categories/categories';
@Component({
    selector: 'scoreBox',
    templateUrl: './scoreBox.html',
})
export class scoreBox implements OnInit {
    refreshSecondScreen;
    goalteam;
    cardteam;

    splashScreen = true;
    splashScreenEffect = false;

    winlist;

    bannerUrl: any;
    splashUrl = scoreSplashUrl;

    constructor(public tournamentsService: TournamentsService, private _uiHelper: uiHelper) {}

    init: boolean;

    styles = {
        leftArea: {
            width: this.tournamentsService.Page_Window_Width - 507 - 39 + 'px',
            overflow: 'hidden',
        },
        rows: {
            'background-color': '#FFFFFF',
            'padding-top': '0px',
            'padding-bottom': '0px',
            'overflow-y': 'scroll',
        },
    };

    ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;

        //this.tournamentsService.getSportFixture('ScoreBox');

        this.refreshSecondScreen = refreshSecondScreen;
        // this.refreshSecondScreen();

        interval(4000).subscribe(x => {
            this.splashScreenEffect = true;

            interval(1000).subscribe(x => {
                this.splashScreen = false;
            });
        });

        this.tournamentsService.getBranchWinList().subscribe(s => {
            //console.warn('WinList', s);
            this.winlist = s;
        });
        this.getSideBanner();
    }
    getSideBanner() {
        this.tournamentsService
            .getSideBanners()
            .then(x => {
                if (x && x.length > 0) {
                    //sidebanner item.PositionId === 12
                    const result = x.find(function(item) {
                        return item.PositionId === 12;
                    });
                    if (result.FileName) {
                        this.bannerUrl = result.FileName;
                    } else {
                        this.bannerUrl = scoreBoxBannerUrl;
                    }
                } else {
                    this.bannerUrl = scoreBoxBannerUrl;
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    sportSelected(e) {}
}
